export default "__VITE_ASSET__BXrMhbqw__"